// extracted by mini-css-extract-plugin
export default {"table":"ViewYoofPrice_table__Mg3ME","search":"ViewYoofPrice_search__GV7eU","icons":"ViewYoofPrice_icons__RjwvV"};